import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {BrickSnake2000} from "../BrickSnake2000";
import {gsap} from "gsap";
import {BrickSnake2000Sound} from "../sound/BrickSnake2000Sound";
import {BrickSnake2000ScatterSymbol} from "../reels/symbols/ScatterSymbol";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class BrickSnake2000BetPresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        BrickSnake2000ScatterSymbol.resetScatterCount();

        tl.add(() => {
            BrickSnake2000.soundPlayer.playLoopingSound(BrickSnake2000Sound.REEL_SPINNING);
        });

        const isFastSpins = BrickSnake2000.apiPlugin.settings.get(APISetting.FAST_SPIN);
        if (isFastSpins) {
            BrickSnake2000.baseGameReelView.reelModels.forEach((reel, index) => tl.add(reel.start(), 0));
        } else {
            BrickSnake2000.baseGameReelView.reelModels.forEach((reel, index) => tl.add(reel.start(), `${0.14*index}`));
        }

        tl.add(() => { flowStateController.finish() });
    }
}